export default __webpack_public_path__ + "static/media/build-a-fish-giveaway.df9e7dca.png";